import { NinjaNextNavigationFactory } from '@ninja/nextjs';
import { AppPermissionLevels } from '../config/app-permission-levels';
import { IRoutesParamsTypes, routesPermissions } from '../config/routes-and-permissions';
import { useWebUser } from '../hooks/useWebUser';

const {
	useWebNavigation,
	Provider,
	PagePermissionGate: ShoryPagePermissionGate,
	useCheckForPermission,
} = new NinjaNextNavigationFactory<AppPermissionLevels, IRoutesParamsTypes>({
	routesPermissions,
	basePermissionLevels: {
		allLoggedInUser: AppPermissionLevels.AllLoggedInUser,
		anonymousUser: AppPermissionLevels.AnonymousUser,
		superAdmin: AppPermissionLevels.NotSupported,
		notLoggedInUser: AppPermissionLevels.NotLoggedInUser,
	},
});

const ShoryNextNavigationProvider = ({ children }: { children: JSX.Element }) => {
	const { isUserLoggedIn } = useWebUser();
	const { navigationReplace } = useWebNavigation();

	return (
		<Provider
			currentUserActions={[]}
			isLoggedInUser={isUserLoggedIn}
			onRedirectToLogin={() => {
				navigationReplace('Login', { src: window.location.href });
			}}
		>
			{children}
		</Provider>
	);
};

export { useWebNavigation, ShoryPagePermissionGate, useCheckForPermission, ShoryNextNavigationProvider };
